import { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination } from 'swiper/modules';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { IconButton } from '@mui/material';
import styles from './ImageSlider.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { ComponentFile } from '../../context/ComponentBriefingContextProvider';

export interface ImagemProposta {
    id: number;
    proposta_id: number;
    referencia: string;
    nome: string;
}

interface ImageSliderProps {
    images: ComponentFile[] | ImagemProposta[] | string[];
    onClose: (close: boolean) => void;
    botoesDeAcao?: boolean;
    isProposta?: boolean;
}

const AMPLIAR_TAMANHO = 550;
const AMPLIAR_TAMANHO_METADE = AMPLIAR_TAMANHO / 2;

export function ImageSlider({ images, botoesDeAcao = true, onClose, isProposta }: ImageSliderProps) {
    const [ampliarImagem, setAmpliarImagem] = useState({ backgroundImage: '' });
    const swiperRef = useRef<any>(null);

    function pegarUrlDaImagem(img: ComponentFile | ImagemProposta | string) {
        if (typeof img === 'string') {
            return img;
        } else {
            return img.referencia;
        }
    }

    function lidarComFechamento() {
        onClose(false);
    }

    const capturaMovimentoMouse = (e: React.MouseEvent<HTMLImageElement>, img: string) => {
        const { clientX, clientY, target } = e.nativeEvent
        const { offsetWidth, offsetHeight } = target as HTMLElement
        const { left, top } = (target as HTMLElement).getBoundingClientRect()

        const xPercentage = ((clientX - left) / offsetWidth) * 100
        const yPercentage = ((clientY - top) / offsetHeight) * 100

        const posY = clientY - AMPLIAR_TAMANHO_METADE
        const posX = clientX - AMPLIAR_TAMANHO_METADE

        setAmpliarImagem((prev) => ({
            ...prev,
            display: 'block',
            top: `${posY}px`,
            left: `${posX}px`,
            backgroundImage: `url(${img})`,
            backgroundPosition: `${xPercentage}% ${yPercentage}%`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: `${offsetWidth * 2}px ${offsetHeight * 2}px`
        }))
    }

    const capturaSaidaMouse = () => {
        setAmpliarImagem((prev) => ({
            ...prev,
            display: 'none',
        }))
    }

    return (
        <div className={`${styles.container_slide_image} ${isProposta ? styles.container_slide_image_proposta : ''}`}>
            <IconButton
                onClick={() => swiperRef.current.swiper.slidePrev()}
                style={{ position: 'absolute', top: '50%', left: -20, zIndex: 3, transform: 'translateY(-50%)', backgroundColor: '#E9775F' }}
            >
                <NavigateBeforeIcon />
            </IconButton>

            <Swiper
                ref={swiperRef}
                modules={[Navigation, Pagination]}
                slidesPerView={1}
                navigation={false}
                pagination={{ clickable: true }}
            >
                {images.map((img, index) => (
                    <SwiperSlide key={index} className={`${styles.container_image} ${styles.container_image_proposta}`}>
                        <img
                            src={pegarUrlDaImagem(img)}
                            alt={`Slide ${index}`}
                            draggable={false}
                            onMouseMove={(e) => capturaMovimentoMouse(e, pegarUrlDaImagem(img))}
                            onMouseLeave={capturaSaidaMouse}
                        />
                        <div className={styles.magnify} style={ampliarImagem}></div>
                        {botoesDeAcao && (
                            <div className={styles.botao_sair}>
                                <IconButton onClick={lidarComFechamento}>
                                    <CloseIcon fontSize='large' />
                                </IconButton>
                            </div>
                        )}
                    </SwiperSlide>
                ))}
            </Swiper>

            <IconButton
                onClick={() => swiperRef.current.swiper.slideNext()}
                style={{ position: 'absolute', top: '50%', right: -20, zIndex: 1, transform: 'translateY(-50%)', backgroundColor: '#E9775F' }}
            >
                <NavigateNextIcon />
            </IconButton>
        </div>
    );
}
